<form [formGroup]="form" class="ps-flex-container-col">
  <mat-form-field>
    <mat-label>{{ 'orders.positions.bm.additionalDemand' | translate }}</mat-label>
    <input formControlName="additionalDemand" matInput/>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'orders.positions.bm.damagePreManufacturing' | translate }}</mat-label>
    <input formControlName="damagePreManufacturing" matInput/>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'orders.positions.bm.damageManufacturing' | translate }}</mat-label>
    <input formControlName="damageManufacturing" matInput/>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'orders.positions.bm.supplierHint' | translate }}</mat-label>
    <textarea formControlName="info" matInput></textarea>
  </mat-form-field>

  <div>
    <button mat-button (click)="discard()">{{ 'orders.positions.bm.updateMeasures.cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="save()">
      {{ 'orders.positions.bm.updateMeasures.submit' | translate }}
    </button>
  </div>
</form>
